function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
},
/*#__PURE__*/
React.createElement("rect", {
  transform: "rotate(45 17 17)",
  x: 15.5,
  y: 8,
  width: 3,
  height: 18,
  rx: 1.5
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M16.5 9a1.5 1.5 0 010 3c-2.172 0-4.5 2.328-4.5 4.5a1.5 1.5 0 01-3 0C9 12.672 12.672 9 16.5 9zM17.5 25a1.5 1.5 0 010-3c2.172 0 4.5-2.328 4.5-4.5a1.5 1.5 0 013 0c0 3.828-3.672 7.5-7.5 7.5z",
  fillRule: "nonzero"
}));

var SvgBig = function SvgBig(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 34,
      height: 34
    }, props), _ref)
  );
};

export default SvgBig;